"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_SearchBarInput = exports.Occ_SearchBarForm = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_SearchBarForm = (0, _styledComponents["default"])('form')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    width: ", ";\n    padding: 0;\n    box-sizing: border-box;\n\n    svg {\n        position: absolute;\n        top: 10px;\n        left: 8px;\n        color: var(--color-primary);\n        font-weight: var(--font-weight-bold);\n    }\n"])), function (props) {
  if (props.size === 'small') {
    return '20%';
  } else if (props.size === 'medium') {
    return '50%';
  } else {
    return '100%';
  }
});
exports.Occ_SearchBarForm = Occ_SearchBarForm;
var Occ_SearchBarInput = (0, _styledComponents["default"])('input')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 8px 25px;\n    width: 100%;\n    border: 1px solid var(--color-primary);\n    border-radius: var(--border-radius-lg);\n\n    &:focus {\n        outline: transparent;\n        border: 1px solid var(--color-primary-highlight);\n    }\n"])));
exports.Occ_SearchBarInput = Occ_SearchBarInput;